import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Home, Sparkles, Search, Calendar, User, Stethoscope, Ambulance, UserPlus, Building2 } from "lucide-react";

const CFG = {
  patient: [
    { to: "/", label: "Home", icon: Home },
    { to: "/ai-triage", label: "Aadhya", icon: Sparkles },
    { to: "/search", label: "Search", icon: Search },
    { to: "/patient", label: "Bookings", icon: Calendar },
    { to: "/reports", label: "Reports", icon: User },
  ],
  doctor: [
    { to: "/doctor", label: "Schedule", icon: Stethoscope },
    { to: "/search", label: "Search", icon: Search },
    { to: "/ai-triage", label: "Aadhya", icon: Sparkles },
  ],
  partner: [
    { to: "/partner", label: "Bookings", icon: Building2 },
    { to: "/search", label: "Search", icon: Search },
  ],
  driver: [
    { to: "/driver", label: "Rides", icon: Ambulance },
    { to: "/", label: "Home", icon: Home },
  ],
  field_executive: [
    { to: "/field", label: "Onboard", icon: UserPlus },
    { to: "/search", label: "Search", icon: Search },
  ],
  admin: [
    { to: "/admin", label: "Admin", icon: User },
    { to: "/search", label: "Search", icon: Search },
    { to: "/field", label: "Onboard", icon: UserPlus },
  ],
};

export default function MobileBottomNav() {
  const { user } = useAuth();
  const loc = useLocation();
  const role = user?.role || "patient";
  const items = CFG[role] || CFG.patient;

  return (
    <nav className="sm:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-xl border-t border-slate-200" data-testid="mobile-nav">
      <div className="grid grid-cols-5">
        {items.slice(0, 5).map((it) => {
          const active = loc.pathname === it.to;
          return (
            <Link key={it.to} to={it.to} data-testid={`bnav-${it.label.toLowerCase()}`}
              className={`flex flex-col items-center justify-center py-2.5 gap-0.5 text-[10px] uppercase tracking-wide transition-colors ${
                active ? "text-teal-700" : "text-slate-500 hover:text-slate-800"
              }`}>
              <it.icon className={`w-5 h-5 ${active ? "text-teal-700" : "text-slate-500"}`} />
              {it.label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
